// FPS-adaptive quality scaling (port of v1 js/performance-monitor.js +
// performance-config.js behavior): rolling FPS average drives pixel-ratio
// and shadow degradation, and exposes a performance score the spawner can
// use to throttle (v1 getAdjustedSpawnInterval).

import type * as THREE from 'three';

const MIN_FPS_THRESHOLD = 30; // v1 PERFORMANCE_SCALING.MIN_FPS_THRESHOLD ballpark
const SAMPLE_WINDOW = 60; // Frames per FPS sample

export class QualityManager {
  fps = 60;
  private frames = 0;
  private windowStart = performance.now();
  private tier = 0; // 0 = full, 1 = reduced pixel ratio, 2 = shadows off
  private lastTierChange = performance.now();

  constructor(private readonly renderer: THREE.WebGLRenderer) {}

  /** Call once per rendered frame. */
  update(): void {
    this.frames++;
    if (this.frames < SAMPLE_WINDOW) return;

    const now = performance.now();
    this.fps = Math.round((this.frames * 1000) / (now - this.windowStart));
    this.frames = 0;
    this.windowStart = now;

    // Give each tier change 5s to settle before judging again
    if (now - this.lastTierChange < 5000) return;

    if (this.fps < MIN_FPS_THRESHOLD && this.tier < 2) {
      this.tier++;
      this.applyTier();
      this.lastTierChange = now;
    } else if (this.fps > 55 && this.tier > 0) {
      this.tier--;
      this.applyTier();
      this.lastTierChange = now;
    }
  }

  /** 1.0 = full performance, lower throttles spawning (v1 performance score). */
  get performanceScore(): number {
    return Math.min(1, this.fps / 60);
  }

  private applyTier(): void {
    switch (this.tier) {
      case 0:
        this.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
        this.renderer.shadowMap.enabled = true;
        break;
      case 1:
        this.renderer.setPixelRatio(1);
        this.renderer.shadowMap.enabled = true;
        break;
      case 2:
        this.renderer.setPixelRatio(1);
        this.renderer.shadowMap.enabled = false;
        break;
    }
  }
}
